import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import {
  GENDER_OPTIONS,
  GENDER_QUESTION,
  genderFemaleSVG,
  genderMaleSVG,
} from '~/pages/communication/gender/libs/components/GenderCommunication/constants'
import { GenderCommunicationStyles as S } from '~/pages/communication/gender/libs/components/GenderCommunication/styles'
import { useDelayedContinue } from '~/shared/hooks/useDelayedContinue'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { eventLogger } from '~/shared/services/eventLogger'
import { TPageProps } from '~/shared/types/commonTypes'

const GENDER_IMAGES: Record<string, string> = {
  male: genderMaleSVG,
  female: genderFemaleSVG,
}

const GenderCommunication = ({ nextPagePath, pageId }: TPageProps) => {
  const { t } = useTranslation()
  const [answer, setAnswer] = useState('')
  const { isAnswersDisabled, handleChange, setIsAnswersDisabled } =
    useDelayedContinue()

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: GENDER_QUESTION,
  })

  return (
    <S.Root>
      <S.ContentWrapper>
        <S.Title>
          <Trans i18nKey="onboarding.quizSingleChoice.genderV2.title" />
        </S.Title>

        <S.Options>
          {GENDER_OPTIONS.map(({ key, i18nKey }) => (
            <S.Card
              key={key}
              $isSelected={answer === key}
              disabled={isAnswersDisabled}
              onClick={() => {
                if (isAnswersDisabled) return
                setAnswer(key)
                eventLogger.logBiUserGender(key)
                handleChange(key, handleContinue)
                setIsAnswersDisabled(true)
              }}
            >
              <S.CardImage src={GENDER_IMAGES[key]} alt={t(i18nKey)} />
              <S.CardLabel>{t(i18nKey)}</S.CardLabel>
            </S.Card>
          ))}
        </S.Options>
      </S.ContentWrapper>
    </S.Root>
  )
}

export default GenderCommunication
